/* HOGGAR — page produit : variantes, galerie (miniatures, flèches, zoom plein écran), guide des tailles, barre d'achat fixe. Vanilla. */
const init = (root) => {
  if (root.dataset.hgReady) return;
  root.dataset.hgReady = '1';
  const $ = (s) => root.querySelector(s);
  const $$ = (s) => [...root.querySelectorAll(s)];
  let data;
  try { data = JSON.parse($('[data-hg-product-json]').textContent); } catch (_) { return; }
  const { variants, colorIndex, product: mainProduct } = data;

  const idInput = $('[data-hg-variant-id]');
  const fieldsets = $$('[data-hg-option]');
  const priceNow = $('[data-hg-price-now]');
  const priceWas = $('[data-hg-price-was]');
  const addBtns = [$('[data-hg-add]'), $('[data-hg-sticky-add]')].filter(Boolean);
  const addLabel = $('[data-hg-add-label]');
  const addPrice = $('[data-hg-add-price]');
  const stickyMeta = $('[data-hg-sticky-meta]');

  /* ---------- Galerie ---------- */
  const stage = $('[data-hg-stage]');
  const thumbs = $('[data-hg-thumbs]');
  const countEl = $('[data-hg-count]');
  const totalEl = $('[data-hg-total]');
  const navs = $$('[data-hg-nav]');
  const order = stage ? [...stage.children] : [];
  const visible = () => (stage ? [...stage.children].filter((f) => !f.hidden) : []);
  let active = 0;

  const setActive = (i) => {
    active = i;
    const n = visible().length;
    if (countEl) countEl.textContent = i + 1;
    navs.forEach((b) => (b.disabled = Number(b.dataset.hgNav) < 0 ? i <= 0 : i >= n - 1));
    if (!thumbs) return;
    [...thumbs.children].forEach((t, k) => t.setAttribute('aria-current', String(k === i)));
    const t = thumbs.children[i];
    if (!t) return;
    // Garde la miniature active visible sans faire défiler la page
    if (thumbs.scrollHeight > thumbs.clientHeight) thumbs.scrollTo({ top: t.offsetTop - (thumbs.clientHeight - t.offsetHeight) / 2, behavior: 'smooth' });
    else thumbs.scrollTo({ left: t.offsetLeft - (thumbs.clientWidth - t.offsetWidth) / 2, behavior: 'smooth' });
  };
  const goTo = (i, smooth = true) => {
    const v = visible();
    if (!stage || !v.length) return;
    i = Math.max(0, Math.min(v.length - 1, i));
    stage.scrollTo({ left: v[i].offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
    setActive(i);
  };
  const buildThumbs = () => {
    const v = visible();
    if (totalEl) totalEl.textContent = v.length;
    root.classList.toggle('hg-pdp--single', v.length < 2);
    if (!thumbs) return;
    thumbs.replaceChildren(...v.map((f, i) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'hg-pdp__thumb' + (f.classList.contains('hg-pdp__slide--photo') && !f.classList.contains('hg-pdp__slide--fit') ? ' hg-pdp__thumb--photo' : '');
      b.setAttribute('aria-label', `Image ${i + 1} sur ${v.length}`);
      const img = new Image();
      img.src = f.dataset.thumb || (f.querySelector('img') || {}).currentSrc || '';
      img.alt = '';
      img.loading = 'lazy';
      b.append(img);
      b.addEventListener('click', () => goTo(i));
      return b;
    }));
  };
  const refreshGallery = () => {
    buildThumbs();
    goTo(0, false);
  };

  if (stage) {
    let raf = 0;
    stage.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const i = Math.round(stage.scrollLeft / stage.clientWidth);
        if (i !== active) setActive(i);
      });
    }, { passive: true });
    stage.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(active + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(active - 1); }
    });
    navs.forEach((b) => b.addEventListener('click', () => goTo(active + Number(b.dataset.hgNav))));
    window.addEventListener('resize', () => goTo(active, false));
  }

  // Images du produit de la variante (produits liés = même design, autre coloris) et visuels de sa couleur
  const showVariant = (v) => {
    if (!stage || !v) return;
    const pid = String(v.product || mainProduct);
    const slides = order.filter((f) => f.dataset.hgProduct);
    const show = (f) => f.dataset.hgProduct === pid && (!f.dataset.hgCode || !v.code || f.dataset.hgCode === v.code);
    if (!slides.some(show)) return;
    slides.forEach((f) => (f.hidden = !show(f)));
    // Ordre de l'admin, avec les photos propres au coloris en tête
    order.forEach((f) => stage.append(f));
    slides.filter((f) => show(f) && f.dataset.hgPhoto != null && f.dataset.hgCode).reverse().forEach((f) => stage.prepend(f));
    refreshGallery();
  };

  /* ---------- Zoom plein écran ---------- */
  const lb = $('[data-hg-lightbox]');
  const lbStage = $('[data-hg-lb-stage]');
  const lbCount = $('[data-hg-lb-count]');
  const lbTotal = $('[data-hg-lb-total]');
  const lbNavs = $$('[data-hg-lb-nav]');
  let lbActive = 0;
  const lbSet = (i) => {
    lbActive = i;
    if (lbCount) lbCount.textContent = i + 1;
    const n = lbStage.children.length;
    lbNavs.forEach((b) => (b.disabled = Number(b.dataset.hgLbNav) < 0 ? i <= 0 : i >= n - 1));
  };
  const lbGo = (i, smooth = true) => {
    const n = lbStage.children.length;
    i = Math.max(0, Math.min(n - 1, i));
    lbStage.querySelectorAll('.is-zoomed').forEach((img) => img.classList.remove('is-zoomed'));
    lbStage.scrollTo({ left: i * lbStage.clientWidth, behavior: smooth ? 'smooth' : 'auto' });
    lbSet(i);
  };
  const openLightbox = (i) => {
    if (!lb || !lbStage || typeof lb.showModal !== 'function') return;
    const v = visible();
    lbStage.replaceChildren(...v.map((f) => {
      const d = document.createElement('div');
      d.className = 'hg-pdp__lb-slide';
      const img = new Image();
      img.src = f.dataset.zoom || (f.querySelector('img') || {}).currentSrc || '';
      img.alt = '';
      img.decoding = 'async';
      const origin = (e) => {
        const r = img.getBoundingClientRect();
        img.style.transformOrigin = `${((e.clientX - r.left) / r.width) * 100}% ${((e.clientY - r.top) / r.height) * 100}%`;
      };
      img.addEventListener('click', (e) => { origin(e); img.classList.toggle('is-zoomed'); });
      img.addEventListener('mousemove', (e) => { if (img.classList.contains('is-zoomed')) origin(e); });
      d.append(img);
      return d;
    }));
    if (lbTotal) lbTotal.textContent = v.length;
    lb.showModal();
    document.documentElement.classList.add('hg-lb-open');
    requestAnimationFrame(() => lbGo(i, false));
  };
  if (lb && lbStage) {
    let raf = 0;
    lbStage.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const i = Math.round(lbStage.scrollLeft / lbStage.clientWidth);
        if (i !== lbActive) { lbStage.querySelectorAll('.is-zoomed').forEach((img) => img.classList.remove('is-zoomed')); lbSet(i); }
      });
    }, { passive: true });
    lbNavs.forEach((b) => b.addEventListener('click', () => lbGo(lbActive + Number(b.dataset.hgLbNav))));
    $('[data-hg-lb-close]').addEventListener('click', () => lb.close());
    lb.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') lbGo(lbActive + 1);
      if (e.key === 'ArrowLeft') lbGo(lbActive - 1);
    });
    lb.addEventListener('close', () => {
      document.documentElement.classList.remove('hg-lb-open');
      goTo(lbActive, false);
    });
  }
  if (stage) {
    stage.addEventListener('click', (e) => {
      const f = e.target.closest('.hg-pdp__slide');
      if (f) openLightbox(Math.max(0, visible().indexOf(f)));
    });
  }
  $$('[data-hg-zoom-open]').forEach((b) => b.addEventListener('click', () => openLightbox(active)));

  /* ---------- Variantes ---------- */
  const selected = () => fieldsets.map((fs) => (fs.querySelector('input:checked') || {}).value);
  const find = (opts) => variants.find((v) => v.options.every((o, i) => o === opts[i]));

  // Marque les valeurs sans variante disponible pour la combinaison courante
  const paintAvailability = () => {
    const cur = selected();
    fieldsets.forEach((fs, i) => {
      fs.querySelectorAll('input').forEach((input) => {
        const test = [...cur];
        test[i] = input.value;
        const v = find(test);
        input.nextElementSibling && input.nextElementSibling.classList.toggle('is-unavailable', !v || !v.available);
      });
    });
  };

  const update = (changedIndex) => {
    let opts = selected();
    let v = find(opts);
    // Combinaison inexistante : on garde l'option modifiée et on prend la première variante compatible
    if (!v && changedIndex != null) {
      v = variants.find((x) => x.options[changedIndex] === opts[changedIndex] && x.available) || variants.find((x) => x.options[changedIndex] === opts[changedIndex]);
      if (v) {
        v.options.forEach((val, i) => {
          const input = [...fieldsets[i].querySelectorAll('input')].find((n) => n.value === val);
          if (input) input.checked = true;
        });
        opts = v.options;
      }
    }
    fieldsets.forEach((fs) => {
      const input = fs.querySelector('input:checked');
      const label = fs.querySelector('[data-hg-option-label]');
      if (input && label) label.textContent = input.dataset.label || input.value;
    });
    paintAvailability();
    if (!v) {
      addBtns.forEach((b) => (b.disabled = true));
      if (addLabel) addLabel.textContent = 'Indisponible';
      return;
    }
    idInput.value = v.id;
    priceNow.textContent = v.price;
    if (addPrice) addPrice.textContent = v.price;
    if (priceWas) { priceWas.hidden = !v.compare; priceWas.textContent = v.compare || ''; }
    addBtns.forEach((b) => (b.disabled = !v.available));
    if (addLabel) addLabel.textContent = v.available ? 'Ajouter au panier' : v.soon ? 'Bientôt disponible' : 'Épuisé';
    const notify = $('[data-hg-notify]');
    if (notify) {
      notify.hidden = v.available || !v.soon;
      const body = $('[data-hg-notify-body]');
      if (body) body.value = `Me prévenir : ${body.dataset.product} — ${v.options.join(' / ')}`;
    }
    if (stickyMeta) {
      const labels = fieldsets.map((fs) => { const i = fs.querySelector('input:checked'); return i ? i.dataset.label || i.value : ''; }).filter(Boolean);
      stickyMeta.textContent = `${labels.join(' / ')} · ${v.price}`;
    }
    if (changedIndex === colorIndex) showVariant(v);
    const url = new URL(location.href);
    if (!v.product || v.product === mainProduct) {
      url.searchParams.set('variant', v.id);
      url.searchParams.delete('couleur');
    } else {
      url.searchParams.delete('variant');
      url.searchParams.set('couleur', v.options[colorIndex]);
    }
    history.replaceState(history.state, '', url);
  };

  fieldsets.forEach((fs, i) => fs.addEventListener('change', () => update(i)));
  paintAvailability();

  // Galerie initiale : la photo du coloris d'arrivée en tête
  buildThumbs();
  setActive(0);
  const first = variants.find((x) => String(x.id) === idInput.value);
  if (first && stage && order.some((f) => !f.hidden && f.dataset.hgPhoto != null && f.dataset.hgCode === first.code && stage.firstElementChild !== f)) showVariant(first);

  // Photos des autres coloris : chargées en arrière-plan une fois la page affichée (changement de couleur instantané)
  const idle = window.requestIdleCallback || ((f) => setTimeout(f, 1200));
  const warm = () => idle(() => order.forEach((f) => {
    const im = f.querySelector('img');
    if (im && f.hidden && im.loading === 'lazy') im.loading = 'eager';
  }));
  if (document.readyState === 'complete') warm(); else window.addEventListener('load', warm, { once: true });

  // ?couleur=… : coloris présélectionné (pastille d'une carte produit)
  const wanted = new URL(location.href).searchParams.get('couleur');
  if (wanted && fieldsets[colorIndex]) {
    const input = [...fieldsets[colorIndex].querySelectorAll('input')].find((n) => n.value === wanted);
    if (input && !input.checked) { input.checked = true; update(colorIndex); }
  }

  /* ---------- Guide des tailles ---------- */
  const guide = $('[data-hg-guide]');
  $$('[data-hg-guide-open]').forEach((b) => b.addEventListener('click', () => guide && guide.showModal()));
  if (guide) guide.addEventListener('click', (e) => { if (e.target === guide || e.target.closest('[data-hg-guide-close]')) guide.close(); });

  /* ---------- Barre d'achat fixe (mobile) quand le bouton principal sort de l'écran ---------- */
  // Visible dès l'arrivée (mobile) tant que le bouton principal n'est pas à l'écran.
  // Tant qu'aucune taille n'a été touchée, la barre propose « Choisir ma taille » et descend jusqu'aux tailles
  // (évite d'ajouter la taille présélectionnée sans y penser).
  const sticky = $('[data-hg-sticky]');
  const mainAdd = $('[data-hg-add]');
  if (sticky && mainAdd && 'IntersectionObserver' in window) {
    sticky.hidden = false;
    const sizeBox = $('.hg-pdp__values--size');
    const sizeInputs = sizeBox ? sizeBox.querySelectorAll('input') : [];
    const sizeField = sizeBox && sizeBox.closest('fieldset');
    let sizeChosen = sizeInputs.length <= 1;
    const label = $('[data-hg-sticky-label]');
    // Tant qu'aucune taille n'est touchée (22/10/2026), le bouton principal dit aussi « Choisir ma taille »
    // et la taille cochée par défaut n'apparaît pas choisie (classe is-unpicked sur le fieldset)
    const setLabel = () => {
      if (label) label.textContent = sizeChosen ? 'Ajouter' : 'Choisir ma taille';
      if (!sizeChosen && addLabel && !mainAdd.disabled) addLabel.textContent = 'Choisir ma taille';
      if (sizeField) sizeField.classList.toggle('is-unpicked', !sizeChosen);
    };
    setLabel();
    // Avant le choix, la barre n'affiche pas la taille présélectionnée (seulement le prix)
    const meta = $('[data-hg-sticky-meta]'), now = $('[data-hg-price-now]');
    const setMeta = () => { if (!sizeChosen && meta && now) meta.textContent = `${now.textContent.trim()} · taille à choisir`; };
    setMeta();
    if (sizeBox) sizeBox.addEventListener('change', () => { sizeChosen = true; setLabel(); });
    // Changement de couleur : update() remet « Ajouter au panier » ; on revient à « Choisir ma taille » si besoin
    fieldsets.forEach((fs) => fs.addEventListener('change', () => { setLabel(); setMeta(); }));
    const askSize = (e) => {
      e.preventDefault(); e.stopImmediatePropagation();
      (sizeField || sizeBox).scrollIntoView({ behavior: 'smooth', block: 'center' });
      const fit = $('[data-hg-fit]');
      if (fit) { fit.classList.remove('is-flash'); void fit.offsetWidth; fit.classList.add('is-flash'); }
    };
    sticky.addEventListener('click', (e) => {
      if (sizeChosen || !e.target.closest('[data-hg-sticky-add]')) return;
      askSize(e);
    }, true);
    mainAdd.addEventListener('click', (e) => { if (!sizeChosen) askSize(e); }, true);
    new IntersectionObserver(([e]) => {
      const on = !e.isIntersecting;
      sticky.classList.toggle('is-visible', on);
      sticky.inert = !on;
    }).observe(mainAdd);
  }
};

const boot = () => document.querySelectorAll('[data-hg-pdp]').forEach(init);
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
document.addEventListener('shopify:section:load', boot);
